<template>
  <div :class="wrapperClass">
    <button :class="containerClass" @click="toggle">
      <Badge :value="cartStore.cartCount" v-if="cartStore.cartCount"></Badge>
      <v-icon :name="icon" :class="iconClass"></v-icon>
    </button>
    <p v-if="label" :class="labelClass">
      {{ label }}
    </p>

    <OverlayPanel ref="cart" :base-z-index="1300">
      <div
        class="flex flex-col w-full sm:max-w-[75vw] md:max-w-[40vw] lg:max-w-[30vw] xl:max-w-[20vw]"
      >
        <div class="flex flex-col">
          <div
            class="flex flex-row align-center justify-center my-10"
            v-if="!cartStore.cartCount"
          >
            <p class="text-center">
              You have not added any items to your order yet
            </p>
          </div>
          <p v-if="hasSaleItems" class="w-full text-center">
            <strong>Buy</strong>
          </p>
          <CompactCartItem
            :item="item"
            :saleItem="true"
            v-for="item in cartStore.saleCartItems"
          ></CompactCartItem>

          <p v-if="hasHireItems" class="w-full text-center">
            <strong>Hire</strong>
          </p>
          <CompactCartItem
            :item="item"
            :saleItem="false"
            v-for="item in cartStore.items"
          ></CompactCartItem>
        </div>

        <a
          v-if="cartStore.cartCount"
          href="/cart"
          class="w-full py-3 rounded-lg primary-bg text-white text-center mt-4"
        >
          <span v-if="hasHireItems && !hasSaleItems"
            >Complete Hire Request</span
          >
          <span v-if="hasHireItems && hasSaleItems"
            >Checkout / Complete Hire Request</span
          >
          <span v-if="hasSaleItems && !hasHireItems">Checkout</span>
        </a>
      </div>
    </OverlayPanel>
  </div>
</template>

<script lang="ts">
import Badge from "primevue/badge";
import OverlayPanel from "primevue/overlaypanel";
import { defineComponent, ref } from "vue";
import CompactCartItem from "./CompactCartItem.vue";
import { CartState } from "../../models/store";
import { useCartStore } from "../../stores/cart";

export default defineComponent({
  components: {
    CompactCartItem,
    OverlayPanel,
    Badge,
  },
  props: {
    icon: {
      type: String,
      default: "fa-shopping-cart",
    },
    iconClass: {
      type: String,
      default: "w-8 h-8",
    },
    containerClass: {
      type: String,
      default: "flex items-center rounded-lg p-overlay-badge",
    },
    label: {
      type: String,
      default: "",
    },
    labelClass: {
      type: String,
      default: "",
    },
    wrapperClass: {
      type: String,
      default: "flex flex-col items-center justify-center",
    },
  },
  data() {
    return {
      showCart: false,
    };
  },
  setup() {
    const cart = ref();
    const cartStore = useCartStore();
    return {
      cart,
      cartStore,
    };
  },
  methods: {
    toggle(event: MouseEvent) {
      (this.$refs.cart as OverlayPanel).toggle(event);
    },
  },
  computed: {
    hasHireItems(): boolean {
      return this.cartStore.hireItemsCount > 0;
    },
    hasSaleItems(): boolean {
      return this.cartStore.saleItemsCount > 0;
    },
  },
});
</script>

<style></style>
